import {
	Directive,
	ElementRef,
	HostListener,
	Input,
	Renderer2
} from '@angular/core';

@Directive({
	selector: '[appHoverCard]'
})
export class HoverCardDirective {
	@Input('appHoverCard') data: { club: string;accountid: string } [] = [];
	private cardElement: HTMLElement | null = null;
	private isHoveringCard = false;
	private mouseInHost = false;

	constructor(private el: ElementRef, private renderer: Renderer2) {}

	@HostListener('mouseenter')
	onHostEnter() {
		this.mouseInHost = true;
		this.showCard();
	}

	@HostListener('mouseleave')
	onHostLeave() {
		this.mouseInHost = false;
		setTimeout(() => {
			if (!this.isHoveringCard) {
				this.hideCard();
			}
		}, 150); // allow brief movement to card
	}

	showCard() {
		if (!this.data?.length || this.cardElement) {return;}

		const card = this.renderer.createElement('div');
		this.renderer.addClass(card, 'hover-card');

		this.data.forEach((item) => {
			const row = this.renderer.createElement('div');
			this.renderer.addClass(row, 'card-row');

			const label = this.renderer.createElement('span');
			const value = this.renderer.createElement('span');
			const btn = this.renderer.createElement('button');

			this.renderer.addClass(label, 'label');
			this.renderer.addClass(value, 'value');
			this.renderer.addClass(btn, 'copy-btn');

			label.innerText = item.club;
			value.innerText = item.accountid || '';
			btn.innerText = '📋';

			this.renderer.listen(btn, 'click', () => {
				navigator.clipboard.writeText(item.accountid || '');

				// Create "Copied!" label
				const copiedLabel = this.renderer.createElement('span');
				copiedLabel.innerText = 'Copied!';
				this.renderer.setStyle(copiedLabel, 'marginLeft', '6px');
				this.renderer.setStyle(copiedLabel, 'fontSize', '0.75rem');
				this.renderer.setStyle(copiedLabel, 'color', '#28a745');
				this.renderer.setStyle(copiedLabel, 'fontWeight', 'bold');

				this.renderer.appendChild(row, copiedLabel);

				setTimeout(() => {
					if (copiedLabel.parentNode) {
						copiedLabel.parentNode.removeChild(copiedLabel);
					}
				}, 1000); // remove after 1 second
			});


			this.renderer.appendChild(row, label);
			this.renderer.appendChild(row, value);
			this.renderer.appendChild(row, btn);
			this.renderer.appendChild(card, row);
		});

		const style = document.createElement('style');
		style.innerHTML = `
	  .card-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 6px;
	  }
	  .label {
		font-weight: 600;
		margin-right: auto;
		color: #333;
	  }
	  .value {
		margin: 0 10px;
		color: #555;
	  }
	  .copy-btn {
		background: none;
		border: none;
		cursor: pointer;
		font-size: 1rem;
		opacity: 0.7;
	  }
	  .copy-btn:hover {
		opacity: 1;
	  }
	`;
		card.appendChild(style);

		// Positioning: must attach first to get height
		Object.assign(card.style, {
			position: 'absolute',
			top: '-9999px',
			left: '-9999px',
			visibility: 'hidden',
			zIndex: '10000',
			background: '#fff',
			border: '1px solid #ccc',
			borderRadius: '8px',
			padding: '10px 14px',
			boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
			fontSize: '0.9rem',
			maxWidth: '400px',
		});

		document.body.appendChild(card);
		const hostRect = this.el.nativeElement.getBoundingClientRect();
		const cardHeight = card.offsetHeight;

		Object.assign(card.style, {
			top: `${hostRect.top + window.scrollY - cardHeight - 8}px`,
			left: `${hostRect.left + window.scrollX}px`,
			visibility: 'visible',
		});

		// Hover detection on card itself
		card.addEventListener('mouseenter', () => {
			this.isHoveringCard = true;
		});
		card.addEventListener('mouseleave', () => {
			this.isHoveringCard = false;
			if (!this.mouseInHost) {this.hideCard();}
		});

		this.cardElement = card;
	}

	hideCard() {
		if (this.cardElement) {
			this.cardElement.remove();
			this.cardElement = null;
		}
	}
}